module.exports = __webpack_public_path__ + "img/icon_tese_chengshu@2x.8219a42e.png";